<template>
  <input
    :id="context.id"
    ref="inputRef"
    v-model="formattedValue"
    type="text"
    :name="context.node.name"
    :disabled="typedDisabled"
    v-bind="context.attrs"
    :class="context.classes.input"
    @blur="context.handlers.blur"
  />
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import { nextTick, watch, watchEffect } from 'vue'
import type { FormKitFrameworkContext } from '@formkit/core'
import { useCurrencyInput, type CurrencyInputOptions } from 'vue-currency-input'

const props = defineProps({
  context: {
    type: Object as PropType<
      FormKitFrameworkContext & { currencyOptions: CurrencyInputOptions }
    >,
    required: true,
  },
})

const typedDisabled = props.context.disabled as boolean

const { formattedValue, inputRef, numberValue, setOptions, setValue } =
  useCurrencyInput(props.context?.currencyOptions)

watch(
  () => props.context,
  async (newValue) => {
    // According to the vue-currency-input docs this should work without the nextTick.
    // However it doesn't load initially without it
    await nextTick()
    setValue(newValue?._value)
  },
  { immediate: true }
)

watch(
  () => props.context.currencyOptions.currency,
  (_newValue) => {
    setOptions(props.context.currencyOptions)
  }
)

// This watchEffect is inside a nextTick as we want to only start watch AFTER the initial set value is done during set up.
nextTick(() =>
  watchEffect(() => {
    if (numberValue.value !== props.context?._value) {
      props.context?.node.input(numberValue.value)
    }
  })
)
</script>
